/**
 * CardTable — 카드 전용 레이아웃용 테이블 서브클래스.
 *
 * <table> 없이 .admin-table-cards 카드들만 있는 페이지에 사용.
 *
 * 마크업 계약:
 *   <div data-card-table>
 *     <div class="admin-table-cards">
 *       <div class="admin-table-card" data-row-id="123">
 *         <div class="admin-table-card__body">…</div>
 *         <div class="admin-table-card__action">
 *           <button data-row-action
 *                   data-action-url="/console/…/123"
 *                   data-action-method="DELETE"
 *                   data-action-confirm="삭제하시겠습니까?"
 *                   data-success-action="remove-row"
 *                   data-success-toast="삭제했습니다.">삭제</button>
 *         </div>
 *       </div>
 *     </div>
 *     <div data-empty-state hidden>…</div>
 *   </div>
 */

import { Table } from "./Table";

export class CardTable extends Table {
    readonly #cards: HTMLElement | null;
    readonly #emptyState: HTMLElement | null;

    constructor(el: HTMLElement) {
        super(el);
        this.#cards = el.querySelector<HTMLElement>(".admin-table-cards");
        this.#emptyState = el.querySelector<HTMLElement>("[data-empty-state]");
    }

    init(): this {
        this.bindActionButtons();
        return this;
    }

    removeRow(id: string): void {
        this.#cards
            ?.querySelector<HTMLElement>(`[data-row-id="${id}"]`)
            ?.remove();
        this.checkEmpty();
    }

    protected checkEmpty(): void {
        const isEmpty = !this.#cards?.querySelector("[data-row-id]");
        if (this.#emptyState) {
            this.#emptyState.hidden = !isEmpty;
        }
        this.el.classList.toggle("is-empty", isEmpty);
    }

    static initAll(): void {
        document
            .querySelectorAll<HTMLElement>("[data-card-table]")
            .forEach((el) => new CardTable(el).init());
    }
}
